import { RootStateOrAny } from "react-redux"
import { AnyAction } from "redux"
import { LOGOUT } from "../auth/actionType";

import {
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  ADD_USER_FAILURE,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  CLEAR_USER_VALUES,
  FETCH_USER_BY_ID_SUCCESS,
  UPDATE_USER_FAILED,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  SEARCH_USERS_REQUEST,
  SEARCH_USERS_SUCCESS,
  SEARCH_USERS_FAILURE,
  FETCH_TOTAL_USERS_REQUEST,
  FETCH_TOTAL_USERS_SUCCESS,
  FETCH_TOTAL_USERS_FAILURE,
  CLEAR_TOTAL_USERS,
} from "./actionType";

export const initialState = {
  user: {
    email: "",
    name: "",
    accessType: "",
    accountStatus: ""
  },
  isLoading: false,
  isAddedSuccessfully: false,
  isSearching: false,
  users: [],
  searchedUsers: [],
  error: "",
  isUpdating: false,
  updateSuccessful: null,
  updateType: "",
  totalUsers: {
    admin: { current: 0 },
    recruiter: { current: 0 },
    interviewer: { current: 0 },
  },
  totalUsersLoading: false,
};

const reducer = (
  state: RootStateOrAny = initialState,
  action: AnyAction
): object => {
  const { type, payload } = action;
  switch (type) {
    case ADD_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
        user: {
          ...state.user,
          ...payload.user,
        },
        error: "",
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAddedSuccessfully: true,
        user: {
          ...initialState.user,
        },
      };
    case ADD_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAddedSuccessfully: false,
        error: payload.error,
      };
    case LOGOUT:
      return initialState;
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: "",
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: payload.users,
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case FETCH_USER_BY_ID_SUCCESS:
      return {
        ...state,
        user: payload.user,
      };
    case CLEAR_USER_VALUES:
      return {
        ...state,
        user: null,
        isUpdating: false,
        updateSuccessful: null,
        isAddedSuccessfully: false,
        updateType: "",
      };
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updateType: payload.updateType,
        user: { ...state.user, ...payload.data },
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        updateSuccessful: true,
      };
    case UPDATE_USER_FAILED:
      return {
        ...state,
        isUpdating: false,
        updateSuccessful: false,
      };
    case SEARCH_USERS_REQUEST:
      return {
        ...state,
        isSearching: true,
        error: "",
      };
    case SEARCH_USERS_SUCCESS:
      return {
        isSearching: false,
        searchedUsers: payload.users,
      };
    case SEARCH_USERS_FAILURE:
      return {
        ...state,
        isSearching: false,
        error: payload.error,
      };
    case FETCH_TOTAL_USERS_REQUEST:
      return {
        ...state,
        totalUsersLoading: true,
      };
    case FETCH_TOTAL_USERS_SUCCESS:
      return {
        ...state,
        totalUsers: payload.data,
        totalUsersLoading: false,
      };
    case FETCH_TOTAL_USERS_FAILURE:
      return {
        ...state,
        totalUsersLoading: false,
      };
    case CLEAR_TOTAL_USERS:
      return {
        ...state,
        totalUsers: initialState.totalUsers,
      };
    default:
      return state;
  }
}

export default reducer;
